export default {
  mounted() {
    this.handleEvent("scroll-to", ({ id }) => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  },
};
